<app-content-box class="embed" *ngIf="linkedInLink">
  <div class="wrapper">
    <div class="editable" *ngIf="auth.isContentManager()">
      <a class="edit" (click)="editLinkedIn()"></a>
    </div>
    <aside [innerHTML]="linkedInLink.uri | safeHtml"></aside>
  </div>
</app-content-box>
